import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLogin, logout } from '../Utils/Cookies.js';

const MenuItem = ({ children, onClick, disabled }) => {
  return <button
    type='button'
    role='menuitem'
    disabled={disabled}
    aria-disabled={disabled}
    className={'w-full px-4 py-3 text-left text-sm font-bold transition ' +
      (disabled ? 'cursor-not-allowed text-gray-300' : 'cursor-pointer text-text-main hover:bg-green-50')
    }
    onClick={onClick}
  >
    {children}
  </button>
}

const TopNavigation = ({ isTop, hero }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false)
  const loggedIn = Boolean(isLogin())

  useEffect(() => {
    if (!menuOpen) return

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [menuOpen])

  const closeAndNavigate = (path) => {
    setMenuOpen(false)
    navigate(path)
  }

  const onLogout = () => {
    logout()
    closeAndNavigate('/')
  }

  return <div className={'site-navigation fixed w-full sm:max-w-md pb-2 justify-between flex z-10' +
    (isTop ? ' ' : ' bg-white border-b border-new-green')
  }>
    {
      menuOpen && <button
        type='button'
        className='fixed inset-0 z-10 cursor-default bg-transparent'
        aria-label='메뉴 닫기'
        onClick={() => setMenuOpen(false)}
      />
    }
    <button
      type='button'
      className='site-logo relative z-20 cursor-pointer border-0 bg-transparent pt-4 pl-4'
      aria-label='홈으로 이동'
      onClick={() => closeAndNavigate(`/`)}
    >
      <img className='w-16' src='/image/tellingpapa_text.png' alt='Telling Papa' />
    </button>
    <div className='relative z-20 mr-4 mt-2'>
      <button
        type='button'
        className='site-menu-toggle flex h-11 w-11 flex-col items-center justify-center gap-1.5 rounded-full bg-white shadow-md'
        aria-label='메뉴 열기'
        aria-haspopup='menu'
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(open => !open)}
      >
        <span className='block h-0.5 w-5 rounded-full bg-text-main' />
        <span className='block h-0.5 w-5 rounded-full bg-text-main' />
        <span className='block h-0.5 w-5 rounded-full bg-text-main' />
      </button>

      {
        menuOpen && <div
          role='menu'
          className='absolute right-0 mt-2 w-44 overflow-hidden rounded-lg bg-white py-1 shadow-lg ring-1 ring-black/5'
        >
          {
            !loggedIn && <MenuItem onClick={() => closeAndNavigate('/login')}>로그인</MenuItem>
          }
          {
            loggedIn && <MenuItem onClick={() => closeAndNavigate('/heroes')}>
              {hero ? '주인공' : '주인공 추가'}
            </MenuItem>
          }
          <MenuItem onClick={() => closeAndNavigate(loggedIn ? '/fairytales' : '/fairytales?sample=true')}>동화</MenuItem>
          <MenuItem onClick={() => {
            setMenuOpen(false)
            window.location.href = 'https://tellingpapa.com/apps/good-job-sticker-v3/index.html'
          }}>칭찬스티커</MenuItem>
          <MenuItem onClick={() => closeAndNavigate('/support/inquiries')}>1:1문의</MenuItem>
          <MenuItem onClick={() => closeAndNavigate('/orders')}>주문내역</MenuItem>
          {
            loggedIn && <MenuItem onClick={onLogout}>로그아웃</MenuItem>
          }
        </div>
      }
    </div>

  </div>
}

export default TopNavigation
